import React, { Component } from "react";
import Helpers from "../../helpers/shared.helper";
import Storage from "../../services/storage.service";
import Payments from "../../services/payments.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import TopUpSuccess from "./top-up-success";
import TopUpFailed from "./top-up-failed";
import TopupPayments from "../../services/topup-payment.service";
import checkModule from "../shared/checkModule";
import CONSTANTS from "../../services/constants.service";
import GTMService from "../../services/gtm.service";

// Confirmation for TAP & KNET Payments
export default class ConfirmationTopup extends Component {

	params = {};
	state = {
		loading: true,
		success: false,
		failed: false,
		error: false
	};

	componentDidMount() {
		if (window) {
            Storage.clear("paymentFailedError");
            if (checkModule.isTopUpKsa) {
                if (window.location.href.indexOf("?") !== -1) {
                    let search = window.location.href.substring(
                        window.location.href.indexOf("?") + 1
                    );
                    search = search.split("&");

                    for (let v = 0; v < search.length; v++) {
                        let pair = search[v].split("=");
                        this.params[pair[0]] = pair[1];
                    }

                    if (window.localStorage.getItem("order_id")) {
                        let status = null;

                        let status_obj = JSON.parse(localStorage.getItem("status"));
                        status = status_obj[Storage.get("session")];
                        let order_id_obj = JSON.parse(
                            window.localStorage.getItem("order_id")
                        );

                        let order_id = order_id_obj[Storage.get("session")];

                        let payment_method = window.localStorage.getItem("selected_payment_method");
                        let status_data = payment_method === CONSTANTS.PAYMENT_TAP_CARD ?
                            status : this.params["status"];
                        let data = {
                            order_id: order_id,
                            status_id: status_data,
                        };

                        Helpers.log("order_id = " + order_id);
                        Helpers.log("Before verifyPayfortResponse data: ", data);
                        Storage.set("paymentFailedError", true, true);
                        Payments.topupVerifyPayfortResponse(data)
                            .then(response => {
                                Storage.set("paymentFailedError", true, true);
                                Helpers.log("topupVerifyPayfortResponse: ", response);
                                Storage.clear("paymentFailedError");
                                if (response.status === 201) {
                                    this.setState({
                                        success: true
                                    });
                                } else {
                                    this.setState({
                                        failed: true
                                    })
                                }
                            })
                            .catch(error => {
                                Helpers.log("verifyPayfortResponse catch: ", error);
                                // Errors.handleError(error);
                                Payments.actionOnPaymentFail();

                                let fgplan = JSON.parse(localStorage.getItem("is_broadband_plan_selected"));
                                if (!fgplan) {
                                    GTMService.action_on_payment_failed();
                                }
                                this.setState({
                                    failed: true
                                })
                            });
                    } else {
                        // no order id found
                        Helpers.log("no order id found");
                        Payments.actionOnPaymentFail();
                        let fgplan = JSON.parse(localStorage.getItem("is_broadband_plan_selected"));
                        if (!fgplan) {
                            GTMService.action_on_payment_failed();
                        }
                        this.setState({
                            failed: true
                        })
                    }
                } 
            }
            if (checkModule.isTopUpKw) {
                if (localStorage.getItem("order_id") && localStorage.getItem("status")) {
                    let order_id = null;
                    let status = null;

                    let order_id_obj = JSON.parse(localStorage.getItem("order_id"));
                    let status_obj = JSON.parse(localStorage.getItem("status"));

                    order_id = order_id_obj[Storage.get("session")];
                    status = status_obj[Storage.get("session")];

                    let data = {
                        order_id: order_id,
                        status_id: status,
                    };

                    Helpers.log("order_id = " + order_id);
                    Helpers.log("Before verifyTAPResponse data: ", data);
                    Storage.set("paymentFailedError", true, true);

                    if (order_id && status) {
                        TopupPayments.topupVerifyConfirmationResponse(data)
                            .then(response => {
                                Storage.set("paymentFailedError", true, true);
                                Helpers.log("topupVerifyTAPResponse: ", response);
                                Storage.clear("paymentFailedError");
                                if (response.status === 201) {
                                    this.setState({
                                        success: true
                                    });
                                } else {
                                    this.setState({
                                        failed: true
                                    })
                                }
                            })
                            .catch(error => {
                                Helpers.log("verifyTAPResponse catch: ", error);
                                // Errors.handleError(error);
                                Payments.actionOnPaymentFail();
                                this.setState({
                                    failed: true
                                })
                            });
                    }
                } else {
                    // no order id found
                    Helpers.log("no order id found");
                    Payments.actionOnPaymentFail();
                    this.setState({
                        failed: true
                    })
                }  
            }

		}
	}

	render() {
		let content = (
			<div className="loading-overlay">
				<div className="relative">
					<SpinnerTimeLoader />
				</div>
			</div>
		);

		if (this.state.success) {
			content = <TopUpSuccess />;
		}
		if (this.state.failed) {
			content = <TopUpFailed />;
		}


		return content;
	}
}